export enum SettingsAndStatisticsTabsEnum {
    Settings = 'settings',
    Statistics = 'statistics',
}
